/**
 * @generated SignedSource<<12ff18070d67c8ab30f2b65cbdf6003a>>
 * @relayHash dd5da56bb8f0cd0cdc28959804b5abfe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00eec6e3d6842c65cfc1b29acd2ede8ad6a9d5b4d27e2e4697af7fc330ff0601

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoard_JiraBoardQuery } from './JiraBoard_JiraBoardQuery.graphql';

import isAssignAgentsInlineM2TechnicalEnabled_provider from '@jira/board__relay-providers/src/AssignAgentsInlineM2TechnicalRelayprovider';
import includeAgentRules_provider from '@jira/board__relay-providers/src/AssignMultiAgentsBoardM2DndRelayProvider';
import isAutoManagedSprintsEnabled_provider from '@jira/board__relay-providers/src/AutoManagedSprintsForHarmonisedBoard';
import withBoardM3_provider from '@jira/board__relay-providers/src/BoardHarmonisationMilestone3';
import boardInlineAssignAgent_provider from '@jira/board__relay-providers/src/BoardInlineAssignAgent';
import shouldPublishRovoBoardContext_provider from '@jira/board__relay-providers/src/BoardRovoContextualActions';
import includeGups_provider from '@jira/board__relay-providers/src/JfindMatureExampleProject';
import withSwimlanesChangeboarding_provider from '@jira/board__relay-providers/src/SwimlanesChangeboarding';
import withTmpHarmonisationOnboarding_provider from '@jira/board__relay-providers/src/TmpHarmonisationOnboarding';

const node: PreloadableConcreteRequest<JiraBoard_JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "00eec6e3d6842c65cfc1b29acd2ede8ad6a9d5b4d27e2e4697af7fc330ff0601",
    "metadata": {},
    "name": "JiraBoard_JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraboard__relayproviderssrcJfindMatureExampleProjecttsx": includeGups_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": withSwimlanesChangeboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": withTmpHarmonisationOnboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": isAutoManagedSprintsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardRovoContextualActionstsx": shouldPublishRovoBoardContext_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHarmonisationMilestone3tsx": withBoardM3_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignAgentsInlineM2TechnicalRelayprovidertsx": isAssignAgentsInlineM2TechnicalEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignMultiAgentsBoardM2DndRelayProvidertsx": includeAgentRules_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": boardInlineAssignAgent_provider
    }
  }
};

export default node;
